import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';
export const Container = styled(animated.div) `
  @apply text-xs box-border w-full p-4;

  p[data-role='menu-subtitle'] {
    @apply m-0 py-2 font-bold;
    color: #a4a4a4;
  }
  ul[data-role='menu-submenu'] {
    @apply list-none p-0 m-0 mb-2;
    color: #656565;
  }
  ul[data-role='menu-submenu']:last-child {
    @apply mb-0 p-0;
  }
  div[data-role='divider']:last-child {
    @apply hidden;
  }
`;
const smallMixin = css `
  @apply py-1;
`;
const mdMixin = css `
  @apply py-0.5;
`;
const lgMixin = css `
  @apply py-2 px-4 text-base;
`;
const sizeMixins = {
    sm: smallMixin,
    md: mdMixin,
    lg: lgMixin,
};
export const Item = styled(animated.li) `
  @apply rounded my-1 mx-0 cursor-pointer flex justify-between items-center px-2;

  ${(props) => (props.size ? sizeMixins[props.size] : mdMixin)};
  color: ${(props) => (props.type === 'action' ? 'var(--text-color-2)' : 'var(--text-color-0)')};
`;
